export function Field({ label, hint, error, required, children, className = "" }) {
  return (
    <label className={`ui-field ${className}`}>
      <span className="ui-field__label">
        {label}{required ? <i>*</i> : null}
      </span>
      {children}
      {error ? <small className="ui-field__error">{error}</small> : hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function TextInput({ className = "", ...props }) {
  return <input className={`ui-input ${className}`} {...props} />;
}

export function SelectInput({ className = "", children, ...props }) {
  return <select className={`ui-input ui-select ${className}`} {...props}>{children}</select>;
}

export function TextArea({ className = "", ...props }) {
  return <textarea className={`ui-input ui-textarea ${className}`} {...props} />;
}

export function Toggle({ checked, onChange, label, description, disabled }) {
  return (
    <label className={`ui-toggle-row ${disabled ? "is-disabled" : ""}`}>
      <span>
        <strong>{label}</strong>
        {description ? <small>{description}</small> : null}
      </span>
      <input type="checkbox" checked={checked} onChange={(event) => onChange?.(event.target.checked)} disabled={disabled} />
      <i aria-hidden="true" />
    </label>
  );
}
